import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AirConditionIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AirConditionIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.3365 14.5049H4.64318C3.7734 14.5049 3.06592 13.7974 3.06592 12.9279V7.86107C3.06592 6.9916 3.77341 6.28412 4.64318 6.28412H21.3365C22.206 6.28412 22.9134 6.99161 22.9134 7.86107V12.9279C22.9134 13.7974 22.206 14.5049 21.3365 14.5049ZM4.64318 7.23196C4.29607 7.23196 4.01376 7.51428 4.01376 7.86108V12.9279C4.01376 13.2747 4.29608 13.5571 4.64318 13.5571H21.3365C21.6833 13.5571 21.9656 13.2747 21.9656 12.9279V7.86108C21.9656 7.51428 21.6833 7.23196 21.3365 7.23196H4.64318Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.7753 14.5049H6.20409C6.06617 14.5049 5.93535 14.445 5.84526 14.3404C5.75517 14.2361 5.71506 14.0979 5.73542 13.9615L6.01311 12.0875C6.04736 11.8551 6.24698 11.683 6.48178 11.683H19.4979C19.7327 11.683 19.9323 11.8551 19.9666 12.0875L20.2439 13.9615C20.2643 14.0979 20.2242 14.2361 20.1341 14.3404C20.044 14.445 19.9132 14.5049 19.7753 14.5049ZM6.7533 13.557H19.2261L19.0891 12.6308H6.8906L6.7533 13.557Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.0953 9.01574C18.7462 9.01574 18.4622 9.29978 18.4622 9.64888C18.4622 9.99801 18.7462 10.282 19.0953 10.282C19.4444 10.282 19.7284 9.99801 19.7284 9.64888C19.7284 9.29979 19.4444 9.01574 19.0953 9.01574Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.5101 17.7159C10.3466 17.7159 10.1871 17.631 10.0994 17.4789L9.37405 16.2225C9.24323 15.9958 9.32067 15.706 9.54745 15.5752C9.77392 15.4438 10.0639 15.5215 10.1948 15.7486L10.9201 17.005C11.051 17.2318 10.9735 17.5215 10.7467 17.6523C10.6721 17.6955 10.5906 17.7159 10.5101 17.7159Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.3527 17.7159C13.1892 17.7159 13.0296 17.631 12.942 17.4789L12.2166 16.2225C12.0858 15.9958 12.1633 15.706 12.39 15.5752C12.6168 15.4438 12.9065 15.5215 13.0374 15.7486L13.7627 17.005C13.8936 17.2318 13.8161 17.5215 13.5893 17.6523C13.5147 17.6955 13.4332 17.7159 13.3527 17.7159Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.1956 17.7159C16.0321 17.7159 15.8725 17.631 15.7849 17.4789L15.0595 16.2225C14.9287 15.9958 15.0062 15.706 15.2329 15.5752C15.4594 15.4438 15.7494 15.5215 15.8803 15.7486L16.6056 17.005C16.7365 17.2318 16.659 17.5215 16.4322 17.6523C16.3576 17.6955 16.2761 17.7159 16.1956 17.7159Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default AirConditionIcon;
